export default "__VITE_ASSET__crPQtwTc__"